import { Provider } from '@angular/core';
import { LEAP_ONBOARDING_SERVICE } from './leap-onboarding.models';
import { LeapOnboardingService } from './leap-onboarding.service';

export function provideLeapOnboardingService(): Provider[] {
	return [
		LeapOnboardingService,
		{
			provide: LEAP_ONBOARDING_SERVICE,
			useExisting: LeapOnboardingService,
		},
	];
}
